import { TurretActor } from "./TurretActor";
import * as Anuto from "../../../../engine/src";
import { AudioManager } from "../../../AudioManager";

export class MinesTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_MINES, position, turret, "texture_atlas_2", false);

        this.base.setFrame("torre_6_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
      
        this.base.on("animationcomplete", () => {
            this.base.setFrame("torre_6_" + this.anutoTurret.level + "_01");
        }, this);
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_6_" + this.anutoTurret.level + "_01");
    }

    public shootMine(): void {

        this.base.anims.play("torre_6_" + this.anutoTurret.level);
        
        AudioManager.playSound("mine_trapdoor");
    }
}
